import React from 'react';

class BookTicketsButton extends React.Component {

  trackEvent(url) {
    ga('send', 'event', 'outbound_links', 'viator', url);
  }
  
  render() {
    var item = this.props.item;
    var url = 'http://www.partner.viator.com/en/16872/tours/'+item.destination+'/'+item.slug+'/'+item.viator_id;
    if (_.isEmpty(item.viator_id)) return null;

    return (
      <div className="book-tickets">
        <a
      href={url}
      target="_blank" className="add btn text-uppercase viator-book-btn"
      onClick={this.trackEvent.bind(this, url)}>
          <i className="fa fa-ticket" style={{ fontSize: 15 }}></i> Book Tickets
        </a>
      </div>
    );
  }
}

module.exports = BookTicketsButton;



// WEBPACK FOOTER //
// ./components/book-tickets-button.js